import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Grid, TextField
} from "@mui/material";

const DriverReminderModal = ({
  driverReminderModalOpen,
  driverReminderForm,
  handleDriverReminderChange,
  handleSendDriverReminder,
  setDriverReminderModalOpen
}) => {
  return (
    <Dialog
      open={driverReminderModalOpen}
      onClose={() => setDriverReminderModalOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Driver Reminder</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="title"
              label="Title"
              value={driverReminderForm.title}
              onChange={handleDriverReminderChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="message"
              label="Message"
              multiline
              minRows={3}
              value={driverReminderForm.message}
              onChange={handleDriverReminderChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDriverReminderModalOpen(false)}>Cancel</Button>
        <Button
          variant="contained"
          color="warning"
          sx={{ color: "white" }}
          onClick={handleSendDriverReminder}
          disabled={!driverReminderForm.title || !driverReminderForm.message}
        >Send</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DriverReminderModal;